import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-confirmation-validation',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogContent, MatIcon],
  templateUrl: './confirmation-validation.component.html',
  styleUrls: ['./confirmation-validation.component.scss']
})
export class ConfirmationValidationComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmationValidationComponent>);
}
